import {
    Button,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Textarea,
    useToast,
    Box,
    IconButton,
    Image, Switch
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import React, { useState } from "react";

function AddNoticeModal({ isOpen, onClose, handleUserSubmit }) {
    const toast = useToast();
    const [noticeDetails, setNoticeDetails] = useState({
        title: "",
        image: "",
        description: "",
        enabled: Boolean("true")
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNoticeDetails((prev) => ({ ...prev, [name]: value }));
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setNoticeDetails((prev) => ({ ...prev, image: reader.result }));
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = () => {
        try {
            handleUserSubmit(noticeDetails);
        } catch (error) {
            console.error(error);
            toast({
                title: "Error!",
                description: "Failed to save notice details. Please try again.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xl">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Add New Notice</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Stack spacing={4}>
                        {/* Image Upload Section */}
                        <FormControl>
                            <FormLabel>Image</FormLabel>
                            <Box display="flex" alignItems="center">
                                <label htmlFor="image-upload">
                                    <IconButton
                                        as="span"
                                        icon={<AddIcon />}
                                        colorScheme="blue"
                                        isRound
                                        aria-label="Add Image"
                                    />
                                </label>
                                <input
                                    id="image-upload"
                                    type="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    onChange={handleImageUpload}
                                />
                                {noticeDetails.image && (
                                    <Image
                                        src={noticeDetails.image}
                                        alt="Preview"
                                        boxSize="50px"
                                        objectFit="cover"
                                        ml={4}
                                    />
                                )}
                            </Box>
                        </FormControl>

                        <FormControl>
                            <FormLabel>Title</FormLabel>
                            <Input
                                name="title"
                                value={noticeDetails.title}
                                onChange={handleInputChange}
                                placeholder="Enter title"
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Description</FormLabel>
                            <Textarea
                                name="description"
                                value={noticeDetails.description}
                                onChange={handleInputChange}
                                placeholder="Description"
                            />
                        </FormControl>

                        <FormControl>
                            <FormLabel>Enable</FormLabel>
                            <Switch
                                name="enabled"
                                value={noticeDetails.enabled}
                                onChange={handleInputChange}
                            />
                        </FormControl>
                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button colorScheme="green" mr={3} onClick={handleSubmit}>
                        Save Notice
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default AddNoticeModal;